import { computed } from "vue";
import { useQuery } from "@tanstack/vue-query";
import { useState } from "@erp/shared/composables/useState";
import { toValue } from "@erp/shared/utils/to-value";
import { useIsOrderCommercialStore } from "../../../_pinia/is-commercial.store";
import { storeToRefs } from "pinia";
import { queries } from "@erp/shared/queries";
/**
 * @description 발주서 상세 모달에서 사용되는 서비스 로직 모음임
 */
export const useOrderDetailAction = (orderId) => {
    const orderIdRef = toValue(orderId);
    const [productId, setProductId] = useState(null);
    const isCommercialStore = useIsOrderCommercialStore();
    const { isCommercial } = storeToRefs(isCommercialStore);
    const readOrderPurchaseProductsQueryOptions = computed(() => {
        const orderId = orderIdRef.value ?? 0;
        return {
            ...queries.order.product(isCommercial.value, orderId),
            enabled: computed(() => !!orderIdRef.value),
        };
    });
    /**
     * @description 발주서와 연결된 구매 제품 조회
     */
    const readOrderPurchaseProducts = useQuery(readOrderPurchaseProductsQueryOptions);
    const readOrderInboundProductsQueryOptions = computed(() => {
        const orderId = orderIdRef.value ?? 0;
        const productIdValue = productId.value ?? 0;
        return {
            ...queries.inbound.productAll(isCommercial.value, {
                orderId,
                productId: productIdValue,
            }),
            enabled: computed(() => !!orderIdRef.value && !!productId.value),
        };
    });
    /**
     * @description 발주서와 연결된 입고 제품 조회
     */
    const readOrderInboundProducts = useQuery(readOrderInboundProductsQueryOptions);
    return {
        readOrderInboundProducts,
        readOrderPurchaseProducts,
        setProductId,
    };
};
